import TwoLevelList from '../../../../components/list/TwoLevelList'
import ListItem from '../../../../components/list/ListItem'
import {userGroupsComparator} from '../../../../atUtils'
import {userComparator} from '../../../../usersSelector/user_group_selector_util'

export default class UsersList extends TwoLevelList {
    constructor({
        additionalClass = '',
    }) {
        super({
            additionalClass: 'usersList ' + additionalClass,
            groupToComponent: group => new ListItem({
                text: group.name.toUpperCase(),
                additionalClass: 'group',
            }),
            itemToComponent: user => new ListItem({
                text: user.lastName + ', ' + user.firstName,
                additionalClass: 'user',
            }),
            itemToGroupId: user => user.userGroupId,
            groupComparator: userGroupsComparator,
            itemComparator: (u1, u2) => userComparator(u1, u2),
        })
    }
}


// WEBPACK FOOTER //
// ./web/js/panels/user/editTeamAssignmentsPanel/components/UsersList.js